import CartaoNumero from './CartaoNumero';
import Aparecer from './Aparecer';
import type { Principal } from '@/pages/gerenciar/painel/financeiro/relatorio/types';
import { formatarCentavos } from '@/pages/loja/utils';

// 4 cartões no topo, em 2×2 (é tudo o que fica acima da dobra).
export default function Principais({ p }: { p: Principal }) {
  const itens = [
    {
      rotulo: 'Entrou',
      valor: formatarCentavos(p.entrou_centavos),
      icone: 'ri-arrow-down-circle-line',
    },
    { rotulo: 'Taxas', valor: formatarCentavos(p.taxas_centavos), icone: 'ri-percent-line' },
    {
      rotulo: 'Despesas',
      valor: formatarCentavos(p.despesas_centavos),
      icone: 'ri-arrow-up-circle-line',
    },
    {
      rotulo: 'Resultado',
      valor: formatarCentavos(p.resultado_centavos),
      icone: 'ri-wallet-3-line',
      destaque: true,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:gap-4">
      {itens.map((it, i) => (
        <Aparecer key={it.rotulo} atraso={i * 50}>
          <CartaoNumero rotulo={it.rotulo} valor={it.valor} icone={it.icone} destaque={it.destaque} />
        </Aparecer>
      ))}
    </div>
  );
}